<template>
  <div class="main">
    <div class="sign-out">
      <SignOutButton />
    </div>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import SignOutButton from '@/pages/auth/components/SignOutButton.vue'
</script>

<style scoped>
.main {
  font-family: Arial, sans-serif;
  padding: 20px 120px;
}

.sign-out {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

@media (max-width: 1120px) {
  .main {
    padding: 60px;
  }
}

@media (max-width: 768px) {
  .main {
    padding: 20px;
  }
  .sign-out {
    padding-right: 0;
  }
}
</style>
